import { en as enF04, sv as svF04 } from "./dictF04";
import { en as enF05, sv as svF05 } from "./dictF05";
import { en as enF06, sv as svF06 } from "./dictF06";
import { en as enF08, sv as svF08 } from "./dictF08";
import { en as enF07, sv as svF07 } from "./dictF07";
import { en as enF09, sv as svF09 } from "./dictF09";
import { en as enF10, sv as svF10 } from "./dictF10";
import { en as enF11, sv as svF11 } from "./dictF11";
import { en as enR03, sv as svR03 } from "./dictR03";

const sv = {
  ...svF04,
  ...svF05,
  ...svF06,
  ...svF08,
  ...svF07,
  ...svF09,
  ...svF10,
  ...svF11,
  ...svR03,
  blackbodyTitle: "Svartkroppsspektrum vid en eller två temperaturer",
  blackbodyNote:
    "Samma termiska strålning kan beskrivas per våglängdsintervall, per frekvensintervall eller per logaritmiskt frekvensintervall, och som energi eller fotonantal. Kurvorna är normerade till den varmare kurvans topp; tabellen anger SI-värden per ytenhet.",
  temperature: "T₁ (K)",
  compareTemperature: "T₂ (K)",
  compareOn: "Jämför med T₂",
  compareOff: "Ta bort T₂",
  variable: "Spektral variabel",
  wavelength: "Per våglängd",
  frequency: "Per frekvens",
  log: "Per ln f",
  quantity: "Storhet",
  energy: "Energi",
  photons: "Fotonantal",
  overlays: "Gränsformer för T₁",
  rayleighJeans: "Rayleigh–Jeans",
  wien: "Wiens strålningslag (1896)",
  threshold: "Tröskelenergi φ (eV)",
  thresholdOff: "Ingen tröskel vid φ = 0.",
  spectrumSvg: "Spektral täthet",
  spectrumDesc:
    "Spektral täthet mot våglängd eller frekvens för en eller två temperaturer med samma axlar. Lodräta streckade linjer markerar varje kurvas topp i den valda variabeln. En skuggad yta visar den del av T₁-spektrumet som ligger över tröskelenergin.",
  axisLambda: "λ ({unit})",
  axisFrequency: "f ({unit})",
  axisDensity: "relativ täthet",
  kT: "kT₁ (eV)",
  lambdaMax: "λmax för I(λ) (μm)",
  frequencyMax: "f vid toppen av I_f (THz)",
  lambdaAtFrequencyMax: "c/f_max (μm)",
  curvePeak: "Den visade kurvans topp ({unit})",
  totalExitance: "Total utstrålning σT₁⁴ (W m⁻²)",
  photonExitance: "Utstrålade fotoner (m⁻² s⁻¹)",
  meanPhoton: "Medelenergi per foton (eV)",
  thresholdX: "a = φ/(kT₁)",
  photonFraction: "Andel av fotonerna över tröskeln",
  energyFraction: "Andel av energin över tröskeln",
  ratioT: "T₂/T₁",
  ratioPeak: "λmax,2/λmax,1",
  ratioTotal: "Kvot total utstrålning, T₂/T₁",
  ratioPhotonsAbove: "Kvot fotonflöde över tröskeln, T₂/T₁",
  blackbodyFormula: String.raw`$x=hf/(kT)$. Per frekvens: $I_f=\dfrac{2\pi(kT)^3}{h^2c^2}\,\dfrac{x^3}{e^x-1}$; per våglängd: $I(\lambda)=\dfrac{2\pi(kT)^5}{h^4c^3}\,\dfrac{x^5}{e^x-1}$. Fotonantal: dividera med $hf=xkT$.`,
  compareScale:
    "Med T₂ påslagen är båda kurvorna skalade till den varmare kurvans topp; den kallare kurvans höjd är relativ till den.",
  photoelectricTitle: "Fotocell: ström, bromsspänning och tröskel",
  photoelectricNote:
    "Enfotonmodell med konstant kvantutbyte η = {eta} över tröskeln och full insamling vid positiv anodspänning. Energifördelningen under Kmax är schematisk; bara dess övre ändpunkt är fysik. V_AC är anodens potential relativt katoden.",
  view: "Vy",
  iv: "Ström mot spänning",
  line: "Bromsspänning mot frekvens",
  lambda: "λ (nm)",
  power: "Ljuseffekt P (mW)",
  hold: "När λ ändras hålls fast",
  fluxClamped: "Fotonflödet kunde inte hållas: effekten är begränsad till 20 mW.",
  holdPower: "Effekten",
  holdFlux: "Fotonflödet",
  cathode: "Katodens utträdesarbete φ_K (eV)",
  anode: "Anodens utträdesarbete φ_A (eV)",
  idealTube: "Anod = katod (bokens idealrör)",
  doublePower: "Fördubbla effekten",
  saveReference: "Spara som jämförelse",
  clearReference: "Ta bort jämförelsen",
  data: "Tentadata HT23:3",
  ivSvg: "Fotoström mot anodspänning",
  ivDesc:
    "Fotoström mot anodens potential relativt katoden. Heldragen kurva: aktuell belysning. Streckad kurva: sparad jämförelse. Lodräta linjer markerar spänningen där strömmen upphör.",
  lineSvg: "Bromsspänning mot frekvens",
  lineDesc:
    "Avläst bromsspänning mot ljusets frekvens. Linjen har lutningen h/e. Den är heldragen där katoden emitterar och streckad där ingen mätpunkt kan finnas. Punkten visar aktuell belysning.",
  axisVoltage: "V_AC (V)",
  axisCurrent: "i (μA)",
  axisFrequency14: "f (10¹⁴ Hz)",
  axisStopping: "V₀ (V)",
  hf: "hf (eV)",
  kMax: "Kmax = hf − φ_K (eV)",
  noEmission: "ingen emission",
  thresholdFrequency: "Tröskelfrekvens φ_K/h (10¹⁴ Hz)",
  thresholdWavelength: "Tröskelvåglängd hc/φ_K (nm)",
  flux: "Fotonflöde P/(hf) (s⁻¹)",
  saturation: "Mättnadsström (μA)",
  stopping: "Avläst bromsspänning V₀ (V)",
  stopVoltage: "V_AC där strömmen upphör (V)",
  contact: "Kontaktpotential (φ_A − φ_K)/e (V)",
  referenceFlux: "Jämförelsens fotonflöde (s⁻¹)",
  referenceSaturation: "Jämförelsens mättnadsström (μA)",
  referenceStopping: "Jämförelsens bromsspänning V₀ (V)",
  fitPlanck: "Anpassning: h = e·lutning (J s)",
  fitWork: "Anpassning: φ = −e·skärning (eV)",
  fitThreshold: "Anpassning: tröskelvåglängd (nm)",
  photoelectricFormula: String.raw`$K_{\max}=hf-\phi_K$ (38.3). Idealrör: $eV_0=K_{\max}$ (38.4). Med olika elektrodmaterial gäller $eV_0=hf-\phi_A$: lutningen $h/e$ består, men skärningen sätts av anoden.`,
};
const en: Record<keyof typeof sv, string> = {
  ...enF04,
  ...enF05,
  ...enF06,
  ...enF08,
  ...enF07,
  ...enF09,
  ...enF10,
  ...enF11,
  ...enR03,
  blackbodyTitle: "Blackbody spectrum at one or two temperatures",
  blackbodyNote:
    "The same thermal radiation can be described per wavelength interval, per frequency interval or per logarithmic frequency interval, as energy or photon number. Curves are normalized to the hotter curve's peak; the table gives SI values per unit area.",
  temperature: "T₁ (K)",
  compareTemperature: "T₂ (K)",
  compareOn: "Compare with T₂",
  compareOff: "Remove T₂",
  variable: "Spectral variable",
  wavelength: "Per wavelength",
  frequency: "Per frequency",
  log: "Per ln f",
  quantity: "Quantity",
  energy: "Energy",
  photons: "Photon number",
  overlays: "Limiting forms for T₁",
  rayleighJeans: "Rayleigh–Jeans",
  wien: "Wien's radiation law (1896)",
  threshold: "Threshold energy φ (eV)",
  thresholdOff: "No threshold at φ = 0.",
  spectrumSvg: "Spectral density",
  spectrumDesc:
    "Spectral density against wavelength or frequency for one or two temperatures on the same axes. Dashed vertical lines mark each curve's peak in the chosen variable. A shaded area shows the part of the T₁ spectrum above the threshold energy.",
  axisLambda: "λ ({unit})",
  axisFrequency: "f ({unit})",
  axisDensity: "relative density",
  kT: "kT₁ (eV)",
  lambdaMax: "λmax of I(λ) (μm)",
  frequencyMax: "f at the peak of I_f (THz)",
  lambdaAtFrequencyMax: "c/f_max (μm)",
  curvePeak: "Peak of the shown curve ({unit})",
  totalExitance: "Total exitance σT₁⁴ (W m⁻²)",
  photonExitance: "Emitted photons (m⁻² s⁻¹)",
  meanPhoton: "Mean photon energy (eV)",
  thresholdX: "a = φ/(kT₁)",
  photonFraction: "Fraction of photons above threshold",
  energyFraction: "Fraction of energy above threshold",
  ratioT: "T₂/T₁",
  ratioPeak: "λmax,2/λmax,1",
  ratioTotal: "Total exitance ratio, T₂/T₁",
  ratioPhotonsAbove: "Photon flux above threshold ratio, T₂/T₁",
  blackbodyFormula: String.raw`$x=hf/(kT)$. Per frequency: $I_f=\dfrac{2\pi(kT)^3}{h^2c^2}\,\dfrac{x^3}{e^x-1}$; per wavelength: $I(\lambda)=\dfrac{2\pi(kT)^5}{h^4c^3}\,\dfrac{x^5}{e^x-1}$. Photon number: divide by $hf=xkT$.`,
  compareScale:
    "With T₂ on, both curves are scaled to the hotter curve's peak; the cooler curve's height is relative to it.",
  photoelectricTitle: "Photocell: current, stopping potential and threshold",
  photoelectricNote:
    "One-photon model with constant quantum yield η = {eta} above threshold and full collection at positive anode voltage. The energy distribution below Kmax is schematic; only its upper end point is physics. V_AC is the anode potential relative to the cathode.",
  view: "View",
  iv: "Current against voltage",
  line: "Stopping potential against frequency",
  lambda: "λ (nm)",
  power: "Light power P (mW)",
  hold: "When λ changes, keep fixed",
  fluxClamped: "Photon flux could not be held: the power is capped at 20 mW.",
  holdPower: "Power",
  holdFlux: "Photon flux",
  cathode: "Cathode work function φ_K (eV)",
  anode: "Anode work function φ_A (eV)",
  idealTube: "Anode = cathode (the book's ideal tube)",
  doublePower: "Double the power",
  saveReference: "Save as comparison",
  clearReference: "Remove comparison",
  data: "Exam data HT23:3",
  ivSvg: "Photocurrent against anode voltage",
  ivDesc:
    "Photocurrent against the anode potential relative to the cathode. Solid curve: current illumination. Dashed curve: saved comparison. Vertical lines mark the voltage where the current stops.",
  lineSvg: "Stopping potential against frequency",
  lineDesc:
    "Measured stopping potential against light frequency. The line has slope h/e. It is solid where the cathode emits and dashed where no data point can exist. The dot shows the current illumination.",
  axisVoltage: "V_AC (V)",
  axisCurrent: "i (μA)",
  axisFrequency14: "f (10¹⁴ Hz)",
  axisStopping: "V₀ (V)",
  hf: "hf (eV)",
  kMax: "Kmax = hf − φ_K (eV)",
  noEmission: "no emission",
  thresholdFrequency: "Threshold frequency φ_K/h (10¹⁴ Hz)",
  thresholdWavelength: "Threshold wavelength hc/φ_K (nm)",
  flux: "Photon flux P/(hf) (s⁻¹)",
  saturation: "Saturation current (μA)",
  stopping: "Measured stopping potential V₀ (V)",
  stopVoltage: "V_AC where the current stops (V)",
  contact: "Contact potential (φ_A − φ_K)/e (V)",
  referenceFlux: "Comparison photon flux (s⁻¹)",
  referenceSaturation: "Comparison saturation current (μA)",
  referenceStopping: "Comparison stopping potential V₀ (V)",
  fitPlanck: "Fit: h = e·slope (J s)",
  fitWork: "Fit: φ = −e·intercept (eV)",
  fitThreshold: "Fit: threshold wavelength (nm)",
  photoelectricFormula: String.raw`$K_{\max}=hf-\phi_K$ (38.3). Ideal tube: $eV_0=K_{\max}$ (38.4). With different electrode materials $eV_0=hf-\phi_A$: the slope $h/e$ stays, but the anode sets the intercept.`,
};
export type PhotonsKey = keyof typeof sv;
const prefix = (entries: Record<PhotonsKey, string>) =>
  Object.fromEntries(
    Object.entries(entries).map(([key, value]) => [`teacher.prep.photons.${key}`, value]),
  );
export const dict = { sv: prefix(sv), en: prefix(en) };
